import * as Sentry from '@sentry/nextjs'
import { getAnonymousId } from '@/utils/ids.utils'

/**
 * Attaches the Ticketure user id to Sentry events. Guests fall back to the per-browser anonymous id
 * so Sentry can still count affected users; on the server that id is unavailable ('') and the user is cleared.
 * ID only — never pass email, name or other PII.
 */
export const setSentryUser = (user: Nullable<Transformed.LoggedInUser>): void => {
  const id = user?.profile.puid ?? getAnonymousId()
  Sentry.setUser(id ? { id } : null)
}
